import { StateSchema } from 'app/providers/StoreProvider';

export const addItemsToOrderIsLoading = (state: StateSchema) =>
    state.addItemsToOrder.isLoading;

export const addItemsToOrderIsCreating = (state: StateSchema) =>
    state.addItemsToOrder.isCreatingOrder;
